﻿import React, { createElement } from 'react';

import { GroupIdentifierDialog } from 'components/GroupIndentifierDialog/GroupIdentifierDialog';
import { LicenseInfoDialog } from 'components/LicenseInfoDialog/LicenseInfoDialog';
import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { TransactionApi } from 'apis/TransactionApi';
import { ReportComponent } from 'apis/ReportApi';
import { Card, Col } from 'react-bootstrap';
import { copyToClipboard } from 'utils';

import 'pages/reports/components/GenericHTML/styles/generic-html.scss';

interface GenericHTMLProps {
	component: ReportComponent;
	currentDialog?: JSX.Element | undefined;
	index: number;
	isSubReport?: boolean;
	loading: boolean;
	setCurrentDialog?: (dialog: JSX.Element | undefined) => void;
}

export function GenericHTML({
    component,
    currentDialog,
    index,
    isSubReport = false,
    loading,
    setCurrentDialog
}: GenericHTMLProps) {

    // DO NOT DELETE this function is used by the database
    const OpenDialog = async (dialogType: string, data: any) => {

        switch (dialogType) {

            case 'ChangeIdentifierDialog':
                if (setCurrentDialog) {

                    const id = JSON.parse(data).currentIdentifier;

                    setCurrentDialog(
                        <GroupIdentifierDialog
                            onCancel={() => {

                                setCurrentDialog(undefined);

                            }}
                            code={id}
                            setShowEditCode={() => null}
                            show={true}
                        />
                    );

                }
                break;
            case 'UsesRemainingDialog':
                if (setCurrentDialog) {

                    const id = JSON.parse(data).transactionId;
                    try {

                        const details = await TransactionApi.Get(id);
                        setCurrentDialog(
                            <LicenseInfoDialog
                                transactionDetails={details}
                            />
                        );

                    } catch {

                        // Failed to load transaction details

                    }

                }
                break;
            default:
                break;

        }

    };

    const CopyItemToClipboard = (text: string) => {

        copyToClipboard(text);

    };

    const getHTML = (dataItem: any): any => {

        const htmlChildren = [];
        const keys = Object.keys(dataItem);
        const validHTMLKeys = ['input', 'div', 'h1', 'h2', 'h3', 'h4', 'p', 'a'];

        // get all values and put them in place then create one html tag with children if necessary
        let tagType = '';
        let className = '';
        let type = '';
        let onClick = '';
        let value = '';

        for (let index = 0; index < keys.length; index++) {

            const element = keys[index];
            if (validHTMLKeys.includes(element)) {

                tagType = element;
                className = dataItem[element]['@class'] ?? '';
                type = dataItem[element]['@type'] ?? '';
                onClick = dataItem[element]['@onclick'] ?? '';
                value = dataItem[element]['@value'] ?? '';
                const childKeys = Object.keys(dataItem[element]);
                if (typeof dataItem[element] !== 'string' && dataItem[element].length > 0) {

                    for (let index = 0; index < dataItem[element].length; index++) {

                        const child = dataItem[element][index];
                        htmlChildren.push(getHTML(child));

                    }

                } else {

                    for (let childIndex = 0; childIndex < childKeys.length; childIndex++) {

                        const child = childKeys[childIndex];
                        if (validHTMLKeys.includes(child)) {

                            htmlChildren.push(getHTML(dataItem[element]));

                        }

                    }

                }
                if (typeof dataItem[element] === 'string') {

                    htmlChildren.push(dataItem[element]);

                } else {

                    if (dataItem[element]['#text']) {

                        htmlChildren.push(dataItem[element]['#text']);

                    }

                }

            }

        }
        if (onClick === '' || onClick === undefined) {

            onClick = `null`;

        }
        return createElement(tagType, { className, onClick: eval('() => ' + onClick), type, value }, ...htmlChildren);

    };

    return (
        <>
            <Col
                className="component-wrapper__col "
                key={`${component.ComponentId}-${index}`}
                lg={isSubReport ? 12 : component.WidthLg}
                md={isSubReport ? 12 : component.WidthMd}
                sm={isSubReport ? 12 : component.WidthSm}
                xl={isSubReport ? 12 : component.WidthXl}
                xxl={component.WidthXl}
            >
                {loading ? (
                    <GMetrixLoader className="find-content-dialog__loader" />
                ) : (
                    <>
                        <Card className="border border-primary" style={{ width: 'auto' }}>
                            <Card.Body>
                                <Card.Title>
                                    <div>
                                        {component.Title}
                                    </div>
                                </Card.Title>
                                {getHTML(component.Results?.Template)}
                            </Card.Body>
                            <Card.Footer className="text-muted">
                                <div dangerouslySetInnerHTML={{ __html: component.Description as any }}></div>
                            </Card.Footer>
                        </Card>
                    </>
                )}
            </Col>
        </>
    );

}
